/* unplugin-vue-components disabled */import script from "./PhraseSelectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhraseSelectModal.vue?vue&type=script&setup=true&lang=ts"

import "./PhraseSelectModal.vue?vue&type=style&index=0&id=08aebd2c&lang=scss&scoped=true"
import "./PhraseSelectModal.vue?vue&type=style&index=1&id=08aebd2c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08aebd2c"]])

export default __exports__